import { useState, useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import InsightPostCover from "../../../components/Insights/InsightPostCover/insight-post-cover";
import styles from "./insight-post.module.css";
import { IPostInsight } from "../../../interfaces/insightPost";

const InsightPost = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [post, setPost] = useState<IPostInsight | null>();
  const { id } = useParams();

  const createList = (list: string[]): any => {
    return list.map((item, index) => {
      return (
        <li key={index} className={styles.lista_item}>
          {item}
        </li>
      );
    });
  };

  const onCreatePost = (item: any) => {
    if (item.type === "text") {
      return (
        <div className={styles.text}>
          <p className={styles.text_paragraph}>{item.text}</p>
        </div>
      );
    }

    if (item.type === "image") {
      return <img className={styles.img_post} src={item.text} alt="" />;
    }

    if (item.type === "list") {
      return (
        <div className={styles.text}>
          <p className={styles.text_paragraph}>{item.text}</p>
          <ul className={styles.servico_lista}>
            {createList(item.list || [])}
          </ul>
        </div>
      );
    }

    if (item.type === "link") {
      return (
        <div className={styles.link}>
          <p className={styles.text_link}>{item.text}</p>
          <p className={styles.text_link}>
            <a href={item.link}>
              <b>{item.link}</b>
            </a>
          </p>
        </div>
      );
    }

    if (item.type === "video") {
      const videoCode = item.text.split("/").pop();

      return (
        <div className={styles.video}>
          <iframe
            width="315"
            height="560"
            src={`https://www.youtube.com/embed/${videoCode}`}
            title="YouTube video player"
            style={{ border: 0 }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      );
    }

    return <p> </p>;
  };

  const LoadingOverlay = () => (
    <div className={styles.loadingOverlay}>
      <div className={styles.spinner}></div>
    </div>
  );

  useEffect(() => {
    const onLoadInsightById = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) {
          console.error("Erro: API URL não definida.");
          return;
        }

        const response = await fetch(`${apiUrl}/insights?id=${id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const resData = await response.json();

        if (!response.ok) {
          alert(
            `${resData.message} ${resData.details}` || "Erro ao buscar insight."
          );
          return;
        }

        return resData.data as IPostInsight;
      } catch (error) {
        alert("Erro ao buscar insight: " + error);
        return;
      }
    };

    if (id) {
      setLoading(true);

      onLoadInsightById()
        .then((data) => {
          if (data) {
            const [year, month, day] = data.date
              ? data.date.split("T")[0].split("-")
              : ["01", "01", "2024"];
            data.date = [day, month, year].join("/");
            data.username = data.user
              ? `${data.user.firstname} ${data.user.lastname}`
              : "Equipe TruEvidence";
            setPost(data);
            setLoading(false);
          } else {
            setPost({});
            setLoading(false);
          }
        })
        .catch(() => setLoading(false));
    } else {
      setPost({});
    }
  }, [id]);

  return (
    <>
      {loading ? (
        <main className={styles.empty_main}>
          <LoadingOverlay />
        </main>
      ) : (
        <main className={styles.post_main}>
          <InsightPostCover
            title={post?.title || ""}
            alt="Cover da página post."
          />
          <section className={styles.descricao_section}>
            <h1 className={styles.post_title}>{post?.title}</h1>
            <div className={styles.post_date}>
              <span>
                <b>{`Postado por ${post?.username || "Equipe TruEvidence"}`}</b>
              </span>
              <span>
                <i>{`Em ${post?.date || "01/01/2024"}`}</i>
              </span>
            </div>
            {post?.paragraphs?.map((item) => onCreatePost(item))}

            <div className={styles.btns_div}>
              <NavLink to="/insights">
                <button className={styles.btn_produto}>{" Voltar"}</button>
              </NavLink>
            </div>
          </section>
        </main>
      )}
    </>
  );
};

export default InsightPost;
